module.exports = __webpack_public_path__ + "img/yourStory.3d497b6.webp";